import { z } from 'zod';
import { SavedCard } from 'src_server/types/getSavedCards';

export const Assignee = z.object({
    name: z.string(),
    id: z.number(),
    type: z.literal('account'),
});

export type AssigneeType = z.infer<typeof Assignee>;

export const InputSchema = z.object({
    customerId: z.number(),
    body: z.object({
        merchantRefNum: z.string(),
        amount: z.string(),
        currencyCode: z.string(),
        paymentHandleToken: z.string(),
        description: z.string(),
        channel: z.literal('backoffice'),
        assignee: Assignee.nullable(),
        paymentMethod: SavedCard,
    }),
});

export const SuccessResponseSchema = z.object({});

type TSuccessResponse = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    errors: z.array(
        z.object({
            code: z.string().optional().nullable(),
            message: z.string().optional().nullable(),
        })
    ),
});

type TErrorResponse = z.infer<typeof ErrorResponseSchema>;

export type TResponseType =
    | { responseStatus: 'success'; response: TSuccessResponse }
    | { responseStatus: 'error'; data: TErrorResponse };
